module.exports = __webpack_public_path__ + "img/hr-pita.d96d135d.png";